<!-- 阶梯价格表 -->
<template>
  <transition name="el-zoom-in-top">
    <div class="ladder-price">
      <el-table :data="tableData" border class="ladder-price__table">
        <el-table-column 
          align="center" 
          prop="0" 
          label="板厚/价格" 
          width="100"
          class-name="ladder-price__table__firstColumn"
          label-class-name="ladder-price__table__firstCell"
        >
          <template slot="header" slot-scope="scope">
            <div class="ladder-price__table__bias">
                <div class="top">面积</div>
                <div class="bottom">板厚</div>
              </div>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="1" label="0.5~5㎡" />
        <el-table-column align="center" prop="2" label="5~20㎡" />
        <el-table-column align="center" prop="3" label="20~50㎡" />
        <el-table-column align="center" prop="4" label="50~100㎡" />
        <el-table-column align="center" prop="5" label="100~200㎡" />
        <el-table-column align="center" prop="6" label="≥200㎡" />
      </el-table>
    </div>
  </transition>
</template>

<script>
import { getPriceList } from '@@/api/pcb'

export default {
  props: {
    // 板子层数
    blayer: {
      type: Number,
      default: 2
    },
  },
  data() {
    return {
      list: {}
    }
  },
  computed: {
    tableData() {
      return this.list[this.blayer] || []
    }
  },
  created() {
    getPriceList().then(res => {
      this.list = res.data || {}
    })
  }
}
</script>

<style lang="scss" scoped>
.ladder-price {
  margin: 0 20px 18px;
  padding: 20px;
  border-radius: 5px;
  border: 1px solid #EBEEF5;
  .ladder-price__table {
    ::v-deep {
      td, th {
        padding: 4px 0;
        font-weight: 400;
        color: #666666;
      }
      th,
      .ladder-price__table__firstColumn {
        background-color: #F5F7FA;
      }
      .ladder-price__table__firstCell.is-leaf {
        position: relative;
        &::before {
          content: "";
          position: absolute;
          top: 1px;
          left: 0;
          display: block;
          width: 1px;
          height: 110px;
          background-color: #EBEEF5;
          transform: rotate(-73deg);
          transform-origin: top;
        }
      }
    }
    
    .ladder-price__table__bias {
      line-height: 1;
      .top {
        text-align: right;
        box-sizing: border-box;
      }
      .bottom {
        text-align: left;
        box-sizing: border-box;
      }
    }
  }
}
</style>